import { DownloadIcon } from '~components/icons';
import { Button } from '~modules/media-library/view/Button';

type DownloadDetailProps = {
  downloadUrl?: string;
  isLoading?: boolean;
  onDownload: (url: string) => void;
  error?: boolean;
};

export function DownloadDetail({ error, isLoading, downloadUrl, onDownload }: DownloadDetailProps) {
  return (
    <div className="flex justify-between items-center h-8 font-sans text-black ">
      {isLoading && !error ? (
        <>
          <div className="bg-gray rounded-full h-4 animate-pulse w-1/3" />
          <div className="bg-gray rounded h-6 w-6 animate-pulse" />
        </>
      ) : !!downloadUrl && !error ? (
        <>
          <div className="text-base pr-2">
            <a href={void 0} onClick={() => onDownload(downloadUrl)}>
              Start download
            </a>
          </div>
          <Button variant="icon" onClick={() => onDownload(downloadUrl)}>
            <DownloadIcon />
          </Button>
        </>
      ) : (
        <div className="text-red">Unknown error</div>
      )}
    </div>
  );
}
